export default __webpack_public_path__ + "a4228b035fcb8b92ae6a5b99d9ef6c6d.svg";